import { useParams } from "react-router-dom";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router";
import { useAuth } from "../components/AuthProvider.tsx";
import Moment from "moment-timezone";
import Application from "../models/Application.tsx"
import AdditionalDocument from "../models/AdditionalDocument.tsx";
import ApplicationLog from "../models/ApplicationLog.tsx";
import MenuComponent from "../components/Menu.tsx";
import DocumentComponent from "../components/Document.tsx";
import AdditionalDocumentComponent from "../components/AdditionalDocument.tsx";
import CommentComponent from "../components/Comment.tsx";

function AdminApplication() {
  const { authorization, SetAuthorization } = useAuth();

  const NewApplication = () => {
    const application: Application = {
      Token: "",
      ApplicationId: 0,
      BusinessId: 0,
      ApplicationStatusId: 1,
      CaseManager: "",
      FirstName: "",
      LastName: "",
      JobTitle: "",
      JobNumber: "",
      JobOfferId: null,
      Schedule1Id: null,
      LanguageTestResultId: null,
      PassportScanId: null,
      ProofOfStatusId: null,
      ProofOfWorkExperienceId: null,
      IntentToResideId: null,
      EducationCredentialId: null,
      CanadianCredentialId: null,
      RecommendationApplicationId: null,
      AdditionalDocuments: [],
      IsComplete: false
    }
    return application;
  }

  const navigate = useNavigate();
  const { applicationId } = useParams();
  const [application, SetApplication] = useState(NewApplication());
  const [logs, SetLogs] = useState<ApplicationLog[]>([]);

  useEffect(() => {
    if (authorization && applicationId) {
      fetch("/api/application?token=" + authorization.Token + "&applicationId=" + applicationId)
        .then(response => response.json())
        .then(data => SetApplication(data))
        .catch(error => console.error(error));

      fetch("/api/applicationlog?token=" + authorization.Token + "&applicationId=" + applicationId)
        .then(response => response.json())
        .then(data => SetLogs(data))
        .catch(error => console.error(error));
    }
  }, [authorization]);

  const Submit = async (event: React.ChangeEvent<any>) => {
    event.preventDefault();

    try {
      const ipResponse = await fetch("https://api.ipify.org?format=json");
      const ipData = await ipResponse.json();
      application.IP = ipData.ip;
    } catch {
      application.IP = "";
    }

    application.Token = authorization.Token;
    const options = {
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(application)
    };

    fetch("/api/application", options)
      .then(response => response.text)
      .then(data => {
        navigate("/admin/applications");
      })
      .catch(error => console.error(error));
  }

  const OnChange = (event: React.ChangeEvent<any>) => {
    const { name, value } = event.target;
    SetApplication((prevState) => ({ ...prevState, [name]: value }));
  }

  const AddAdditionalDocument = (document: AdditionalDocument) => {
    var current = application;
    current.AdditionalDocuments = [...current.AdditionalDocuments, document];
    SetApplication(current);
  }

  const DeleteAdditionalDocument = (index: number) => {
    var current = application;
    current.AdditionalDocuments.splice(index, 1);
    SetApplication(current);
  }

  return (
    <>
      <MenuComponent page="Update Application" />

      <section id="main">
        <div className="container">
          <p>Please note, <strong>all fields are mandatory</strong> unless otherwise indicated in order to submit an application.</p>
          <form onSubmit={Submit}>
            <p>
              <strong>Application Number:</strong> {application.JobNumber} 
              <span className="tooltip">
                {application.ApplicationStatusId == 1 && <><img src="/images/Submitted.png" alt="Submitted" /><span className="tooltiptext">Submitted</span></>}
                {application.ApplicationStatusId == 2 && <><img src="/images/Under-Review.png" alt="Reviewed" /><span className="tooltiptext">Under Review</span></>}
                {application.ApplicationStatusId == 3 && <><img src="/images/Incomplete.png" alt="Incomplete" /><span className="tooltiptext">Incomplete</span></>}
                {application.ApplicationStatusId == 4 && <><img src="/images/Complete.png" alt="Complete" /><span className="tooltiptext">Complete</span></>}
                {application.ApplicationStatusId == 5 && <><img src="/images/Decline-Recommend.png" alt="Declined" /><span className="tooltiptext">Decline to Recommend</span></>}
                {application.ApplicationStatusId == 6 && <><img src="/images/Withdrawn.png" alt="Withdrawn" /><span className="tooltiptext">Withdrawn</span></>}
                {application.ApplicationStatusId == 7 && <><img src="/images/Ineligible.png" alt="Ineligible" /><span className="tooltiptext">Ineligible</span></>}
                {application.ApplicationStatusId == 8 && <><img src="/images/Recommended.png" alt="Recommended" /><span className="tooltiptext">Recommended</span></>}
              </span>
            </p>
            {application.CaseManager && 
              <p>
                <strong>Case Manager:</strong> {application.CaseManager}
              </p>
            }
            {application.Owner &&
              <p>
                <strong>Employer:</strong> {application.Owner}
              </p>
            }
            <p className="half">
               <label>Application Status
                <select name="ApplicationStatusId" value={application.ApplicationStatusId} onChange={OnChange}>
                  <option value="1">Submitted</option>
                  <option value="2">Under Review</option>
                  <option value="3">Incomplete</option>
                  <option value="4">Complete</option>                  
                  <option value="5">Decline To Recommend</option>
                  <option value="6">Withdrawn</option>
                  <option value="7">Ineligible</option>
                  <option value="8">Recommended</option>
                </select>
              </label>
            </p>
            <p>
              <label>Applicant First Name
                <input type="text" name="FirstName" value={application.FirstName} required maxLength={50} onChange={OnChange} />
              </label>
            </p>
            <p>
              <label>Applicant Last Name
                <input type="text" name="LastName" value={application.LastName} required maxLength={50} onChange={OnChange} />
              </label>
            </p>
            <p>
              <label>Job Title
                <input type="text" name="JobTitle" value={application.JobTitle} required maxLength={50} onChange={OnChange} />
              </label>
            </p>

            <h2>Documents</h2>
            <p><em>DOC and PDF file types accepted. 4MB max file size.</em></p>
            <DocumentComponent identifier="Upload0" label="Job Offer Form" application={application} property_Id="JobOfferId" property_filename="Filename_JobOffer" property_createdOn="CreatedOn_JobOffer" SetApplication={SetApplication} />
            <DocumentComponent identifier="Upload1" label="Schedule 1" application={application} property_Id="Schedule1Id" property_filename="Filename_Schedule1" property_createdOn="CreatedOn_Schedule1" SetApplication={SetApplication} />
            <DocumentComponent identifier="Upload2" label="Language Test Results" application={application} property_Id="LanguageTestResultId" property_filename="Filename_LanguageTestResult" property_createdOn="CreatedOn_LanguageTestResult" SetApplication={SetApplication} />
            <DocumentComponent identifier="Upload3" label="Passport Scan" application={application} property_Id="PassportScanId" property_filename="Filename_PassportScan" property_createdOn="CreatedOn_PassportScan" SetApplication={SetApplication} />
            <DocumentComponent identifier="Upload4" label="Proof of Status (optional)" application={application} property_Id="ProofOfStatusId" property_filename="Filename_ProofOfStatus" property_createdOn="CreatedOn_ProofOfStatus" SetApplication={SetApplication} />
            <DocumentComponent identifier="Upload5" label="Proof of Work Experience" application={application} property_Id="ProofOfWorkExperienceId" property_filename="Filename_ProofOfWorkExperience" property_createdOn="CreatedOn_ProofOfWorkExperience" SetApplication={SetApplication} />
            <DocumentComponent identifier="Upload6" label="Intent to Reside Declaration" application={application} property_Id="IntentToResideId" property_filename="Filename_IntentToReside" property_createdOn="CreatedOn_IntentToReside" SetApplication={SetApplication} />
            <DocumentComponent identifier="Upload7" label="RCIP Recommendation Application" application={application} property_Id="RecommendationApplicationId" property_filename="Filename_RecommendationApplication" property_createdOn="CreatedOn_RecommendationApplication" SetApplication={SetApplication} />

            <h3>Education Documents</h3>
            <p><em>Note: only one education document is required</em></p>
            <DocumentComponent identifier="Upload8" label="Education Credential Assessment (ECA)" application={application} property_Id="EducationCredentialId" property_filename="Filename_EducationCredential" property_createdOn="CreatedOn_EducationCredential" SetApplication={SetApplication} />
            <DocumentComponent identifier="Upload9" label="Canadian Education Credential" application={application} property_Id="CanadianCredentialId" property_filename="Filename_CanadianCredential" property_createdOn="CreatedOn_CanadianCredential" SetApplication={SetApplication} />

            <AdditionalDocumentComponent application={application} AddAdditionalDocument={AddAdditionalDocument} DeleteAdditionalDocument={DeleteAdditionalDocument} />

            <p className="formButton biggerSpace"><input type="submit" value="Update Application" /></p>
          </form>

          <CommentComponent applicationId={Number(applicationId)} businessId={application.BusinessId} />

          {logs.length > 0 &&
            <>
              <h2>Application Log</h2>
              <div className="appList appLog">
                <article>
                  <div>User</div>
                  <div>Date</div>
                  <div>IP</div>
                </article>
                {logs.map(log => (
                  <article key={log.ApplicationLogId}>
                    <div>{log.ModifiedBy}</div>
                    <div>{Moment.tz(log.ModifiedOn, "America/Chicago").tz(Moment.tz.guess()).format("MMM DD, yyyy hh:mm A")}</div>
                    <div>{log.IP}</div>
                  </article>
                ))}
              </div>
            </>
          }
        </div>
      </section>
    </>
  );
}

export default AdminApplication;